
































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { TEntity } from '@/plugins/podolib/services/entities/Entity';
import { TAcquisition, TPatient } from '@/plugins/podolib/services/entities/EntityPatients';
import { Office, Offices } from '@/plugins/podolib/services/doctor';

import PatientAcquisitionExportationViewer from '@/components/patients/acquisition/exportation/PatientAcquisitionExportationViewer.vue';

@Component({
  components: { PatientAcquisitionExportationViewer },
})
export default class PatientAcquisitionExportationBuilder extends Vue {
  @Prop({ required: true }) private dialog!: boolean;
  @Prop({ required: true }) private patient!: TEntity<TPatient>;
  @Prop({ required: true }) private acquisition!: TEntity<TAcquisition>;

  data: string | null = null;
  mode: 'normal' | 'advanced' = 'normal';
  hideEmail = false;
  hidePhone = false;
  selectedOffice: Offices['selected'] = this.$store.getters['pdc/doctor/selectedOffice']?._id;

  pending = true;
  error: Error | null = null;

  @Watch('mode')
  onModeChanged(state: boolean) {
    this.$pdc.storage!.setUniversal('exportMode', state);
  }

  @Watch('hideEmail')
  onHideEmailChanged(state: boolean) {
    this.$pdc.storage!.setUniversal('exportHideEmail', state);
  }

  @Watch('hidePhone')
  onHidePhoneChanged(state: boolean) {
    this.$pdc.storage!.setUniversal('exportHidePhone', state);
  }

  @Watch('acquisition', { deep: true, immediate: true })
  onAnalysisChanged() {
    if (this.acquisition.analysisType !== 'podosmart') this.mode = 'normal';
  }

  get doctor() {
    return this.$store.state.pdc.doctor.current;
  }

  get offices(): Office[] {
    return this.doctor.offices.items;
  }

  get office(): Office {
    return this.$store.getters['pdc/doctor/getOfficeWithId'](this.selectedOffice);
  }

  get isSafari() {
    return this.$pdc.helper!.browser === 'safari';
  }

  get isDegradedActivity() {
    return this.acquisition?.analysisType === 'podosmart' && this.$pdc.helper?.isDegradedActivity(this.acquisition);
  }

  print() {
    (this.$refs.frame as any).print();

    // Analytics
    this.$pdc.analytics?.actions.trackSuccess('Analysis Printed', {
      patientId: this.patient._id,
      acquisitionId: this.acquisition._id,
      mode: this.mode,
      emailHidden: this.hideEmail,
      phoneHidden: this.hidePhone,
    });
  }

  private setPendingFlag(value: boolean) {
    this.pending = value;
  }

  created() {
    this.mode = this.$pdc.storage!.getUniversal('exportMode') || 'normal';
    this.hideEmail = this.$pdc.storage!.getUniversal('exportHideEmail') || false;
    this.hidePhone = this.$pdc.storage!.getUniversal('exportHidePhone') || false;

    this.$pdc.bus!.on('export:pending:set', this.setPendingFlag);
  }

  beforeDestroy() {
    this.$pdc.bus!.off('export:pending:set', this.setPendingFlag);
  }
}
